export interface ComplaintSubReason {
  id: string
  title: string
  reason: string // 举报原因说明
}

export interface ComplaintType {
  id: string
  title: string
  reason: string // 举报原因说明
  subReason?: ComplaintSubReason[]
}

export const COMPLAINT_TYPES: ComplaintType[] = [
  {
    id: 'inappropriate_content',
    title: '网页包含不适当的骚扰内容',
    reason:
      '请提供页面中含有不适当骚扰内容的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'product_info_false',
    title: '商品信息虚假（品牌/价格/功效）',
    reason:
      '请提供页面中含有商品信息虚假的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'fake_sale',
    title: '销售违禁或侵权商品',
    reason:
      '请提供页面中含有销售违禁或侵权商品的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'fake_promotion',
    title: '虚假促销活动',
    reason:
      '请提供页面中含有虚假促销活动的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'induce_payment',
    title: '诱导私下交易',
    reason:
      '请提供页面中含有诱导私下交易的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'low_quality',
    title: '低俗色情内容',
    reason:
      '请提供页面中含有低俗色情内容的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'personal_attack',
    title: '辱骂或人身攻击',
    reason:
      '请提供页面中含有辱骂或人身攻击的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'content_mismatch',
    title: '内容引起不适',
    reason:
      '请提供页面中含有引起不适内容的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'privacy_violation',
    title: '侵犯隐私行为',
    reason:
      '请提供页面中含有侵犯隐私行为的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'other_violation',
    title: '其他违规行为',
    reason: '请提供页面中含有违规行为的证据(含时间)，便于平台快速处理您的举报',
  },
]

export const COMPLAINT_TYPES_QIWEI: ComplaintType[] = [
  {
    id: 'harassment',
    title: '对我造成骚扰',
    reason:
      '请提供页面中含有对您造成骚扰的证据(含时间)，便于平台快速处理您的举报',
  },
  {
    id: 'inappropriate_content',
    title: '发布不适当内容',
    reason: '',
    subReason: [
      {
        id: 'sexual_content',
        title: '色情',
        reason:
          '请提供页面中含有色情内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'gambling_content',
        title: '赌博',
        reason:
          '请提供页面中含有赌博内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'illegal_content',
        title: '违法犯罪',
        reason:
          '请提供页面中含有违法犯罪内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'political_rumor_content',
        title: '政治谣言',
        reason:
          '请提供页面中含有政治谣言内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'bloody_content',
        title: '暴恐血腥',
        reason:
          '请提供页面中含有暴恐血腥内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'suicide_content',
        title: '自杀自残',
        reason:
          '请提供页面中含有自杀自残内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'cyber_bullying_content',
        title: '网络暴力',
        reason:
          '请提供页面中含有网络暴力内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'other_violation_content',
        title: '其他违规内容',
        reason:
          '请提供页面中含有其他违规内容的证据(含时间)，便于平台快速处理您的举报',
      },
    ],
  },
  {
    id: 'fraudulent_behavior',
    title: '存在欺诈骗钱行为',
    reason: '',
    subReason: [
      {
        id: 'financial_fraud_loan',
        title: '金融诈骗（贷款/提额/套现等）',
        reason:
          '请提供页面中含有金融诈骗内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'financial_fraud_rebate',
        title: '返利',
        reason:
          '请提供页面中含有返利内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'financial_fraud_credit',
        title: '网络兼职刷单',
        reason:
          '请提供页面中含有网络兼职刷单内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'financial_fraud_network_friend',
        title: '网络交友',
        reason:
          '请提供页面中含有网络交友诈骗内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'financial_fraud_investment',
        title: '虚假投资理财',
        reason:
          '请提供页面中含有虚假投资理财内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'financial_fraud_gambling',
        title: '赌博',
        reason:
          '请提供页面中含有赌博内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'financial_fraud_no_delivery',
        title: '收款不发货',
        reason:
          '请提供页面中含有收款不发货内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'financial_fraud_fake_person',
        title: '仿冒他人诈骗',
        reason:
          '请提供页面中含有仿冒他人诈骗内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'financial_fraud_free_delivery',
        title: '免费送诈骗',
        reason:
          '请提供页面中含有免费送诈骗内容的证据(含时间)，便于平台快速处理您的举报',
      },
      {
        id: 'financial_fraud_other',
        title: '其他诈骗行为',
        reason:
          '请提供页面中含有其他诈骗行为的证据(含时间)，便于平台快速处理您的举报',
      },
    ],
  },
  {
    id: 'other_violation',
    title: '投诉其他行为',
    reason: '请提供您举报其他行为的证据(含时间)，便于平台快速处理您的举报',
  },
]
